import { Language, SourceName } from '../../../enums/const-enums';

export interface RassHeaderTranslations {
  title: Record<SourceName, string>;
  button: {
    label: string;
  };
  body: {
    ariaLabel: string;
  };
  modal: {
    title: Record<SourceName, string>;
    body: Record<SourceName, string>;
    button: {
      label: {
        cancel: string;
        confirm: string;
      };
    };
  };
}

const nlTranslations: RassHeaderTranslations = {
  title: {
    [SourceName.EMANDATES]: 'Digitaal incassomachtigen',
    [SourceName.IDEAL]: 'Betalen met iDEAL',
    [SourceName.WERO]: 'Betalen met WERO',
    [SourceName.IDIN]: 'Bevestigen met iDIN',
    [SourceName.LOGIN]: 'Inloggen',
    [SourceName.OTHER]: 'Ondertekenen',
  },
  button: {
    label: 'Annuleren',
  },
  body: {
    ariaLabel:
      'Rabobank opdrachtvenster. Let op: als je SHIFT+TAB gebruikt verlaat je het opdrachtvenster.',
  },
  modal: {
    title: {
      [SourceName.EMANDATES]: 'Annuleer opdracht',
      [SourceName.IDEAL]: 'Annuleer betaling',
      [SourceName.WERO]: 'Annuleer betaling',
      [SourceName.IDIN]: 'Annuleer opdracht',
      [SourceName.LOGIN]: 'Annuleer inloggen',
      [SourceName.OTHER]: 'Annuleer opdracht',
    },
    body: {
      [SourceName.EMANDATES]: 'Weet je zeker dat je de opdracht wil annuleren?',
      [SourceName.IDEAL]: 'Weet je zeker dat je de betaling wil annuleren?',
      [SourceName.WERO]: 'Weet je zeker dat je de betaling wil annuleren?',
      [SourceName.IDIN]: 'Weet je zeker dat je de opdracht wil annuleren?',
      [SourceName.LOGIN]: 'Weet je zeker dat je het inloggen wil annuleren?',
      [SourceName.OTHER]: 'Weet je zeker dat je de opdracht wil annuleren?',
    },
    button: {
      label: {
        cancel: 'Nee',
        confirm: 'Ja',
      },
    },
  },
};

const enTranslations: RassHeaderTranslations = {
  title: {
    [SourceName.EMANDATES]: 'Sign',
    [SourceName.IDEAL]: 'Pay with iDEAL',
    [SourceName.WERO]: 'Pay with WERO',
    [SourceName.IDIN]: 'Confirm with iDIN',
    [SourceName.LOGIN]: 'Login',
    [SourceName.OTHER]: 'Sign',
  },
  button: {
    label: 'Cancel',
  },

  body: {
    ariaLabel:
      'Rabobank signing window. Pay attention: if you use SHIFT+TAB you will leave the signing window.',
  },
  modal: {
    title: {
      [SourceName.EMANDATES]: 'Cancel signing',
      [SourceName.IDEAL]: 'Cancel payment',
      [SourceName.WERO]: 'Cancel payment',
      [SourceName.IDIN]: 'Cancel signing',
      [SourceName.LOGIN]: 'Cancel login',
      [SourceName.OTHER]: 'Cancel signing',
    },
    body: {
      [SourceName.EMANDATES]: 'Are you sure you want to cancel?',
      [SourceName.IDEAL]: 'Are you sure you want to cancel the payment?',
      [SourceName.WERO]: 'Are you sure you want to cancel the payment?',
      [SourceName.IDIN]: 'Are you sure you want to cancel?',
      [SourceName.LOGIN]: 'Are you sure you want to cancel the login?',
      [SourceName.OTHER]: 'Are you sure you want to cancel?',
    },
    button: {
      label: {
        cancel: 'No',
        confirm: 'Yes',
      },
    },
  },
};

const esTranslations: RassHeaderTranslations = {
  title: {
    [SourceName.EMANDATES]: 'Sign',
    [SourceName.IDEAL]: 'Pay with iDEAL',
    [SourceName.WERO]: 'Pay with WERO',
    [SourceName.IDIN]: 'Confirm with iDIN',
    [SourceName.LOGIN]: 'Iniciar sesión',
    [SourceName.OTHER]: 'Sign',
  },
  button: {
    label: 'Cancel',
  },
  body: {
    ariaLabel:
      'Rabobank signing window. Pay attention: if you use SHIFT+TAB you will leave the signing window.',
  },
  modal: {
    title: {
      [SourceName.EMANDATES]: 'Cancel signing',
      [SourceName.IDEAL]: 'Cancel payment',
      [SourceName.WERO]: 'Cancel payment',
      [SourceName.IDIN]: 'Cancel signing',
      [SourceName.LOGIN]: 'Cancel login',
      [SourceName.OTHER]: 'Cancel signing',
    },
    body: {
      [SourceName.EMANDATES]: 'Are you sure you want to cancel?',
      [SourceName.IDEAL]: 'Are you sure you want to cancel the payment?',
      [SourceName.WERO]: 'Are you sure you want to cancel the payment?',
      [SourceName.IDIN]: 'Are you sure you want to cancel?',
      [SourceName.LOGIN]: 'Are you sure you want to cancel the login?',
      [SourceName.OTHER]: 'Are you sure you want to cancel?',
    },
    button: {
      label: {
        cancel: 'No',
        confirm: 'Yes',
      },
    },
  },
};

const ptTranslations: RassHeaderTranslations = {
  title: {
    [SourceName.EMANDATES]: 'Sign',
    [SourceName.IDEAL]: 'Pay with iDEAL',
    [SourceName.WERO]: 'Pay with WERO',
    [SourceName.IDIN]: 'Confirm with iDIN',
    [SourceName.LOGIN]: 'Entrar',
    [SourceName.OTHER]: 'Sign',
  },
  button: {
    label: 'Cancel',
  },
  body: {
    ariaLabel:
      'Rabobank signing window. Pay attention: if you use SHIFT+TAB you will leave the signing window.',
  },
  modal: {
    title: {
      [SourceName.EMANDATES]: 'Cancel signing',
      [SourceName.IDEAL]: 'Cancel payment',
      [SourceName.WERO]: 'Cancel payment',
      [SourceName.IDIN]: 'Cancel signing',
      [SourceName.LOGIN]: 'Cancel login',
      [SourceName.OTHER]: 'Cancel signing',
    },
    body: {
      [SourceName.EMANDATES]: 'Are you sure you want to cancel?',
      [SourceName.IDEAL]: 'Are you sure you want to cancel the payment?',
      [SourceName.WERO]: 'Are you sure you want to cancel the payment?',
      [SourceName.IDIN]: 'Are you sure you want to cancel?',
      [SourceName.LOGIN]: 'Are you sure you want to cancel the login?',
      [SourceName.OTHER]: 'Are you sure you want to cancel?',
    },
    button: {
      label: {
        cancel: 'No',
        confirm: 'Yes',
      },
    },
  },
};

export const rassHeaderTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: esTranslations,
  [Language.PT]: ptTranslations,
};
